<template>
  <div class="RnDownload">
    <h1>苹果用户安装指引</h1>
    <div class="loadone">
      <div class="left">
        <img src="../TempH5/images/xhy.red-150x150.png" alt="">
      </div>
      <div class="right">
        <p>魅爱TV 苹果永久版</p>
        <div @click="downloadBtn"><img src="../RnDownload/images/goDownload@2x.png" alt=""></div>
      </div>
    </div>
    <div class="tip">
      <p>安装说明：<br>点击前往下载下载最新版永久软件(点击前往下载的同时已复制密钥)，期间尽量无其他操作下载完成后，立即启动软件。
      *如打开APP画面空白请 <span @click="downloadBtn">点击我重试。</span></p>
    </div>
    <div class="tipone">
      <p>打开软件，应显示【维护中】，稍后弹窗【强制升级/确认】<br> 点击后等待下载进度达到100%即可正常观影！</p>
    </div>
    <div class="maintain"></div>
    <div class="tips">
      <img src="./images/wrong@2x.png" alt=""/>
      <div class="tips-bottom">
        <div class="q1">
          <span>Q1</span>
          <p>打开后不是视频软件，没有维护中啊？</p>
        </div>
        <div class="q1 a1">
          <span>A1</span>
          <p>请退出软件，更新复制第一步解锁密码，重新启动APP尝试。</p>
        </div>
        <div class="line"></div>
        <div class="q1 q2">
          <span>Q2</span>
          <p>看不了啊，提示无网络</p>
        </div>
        <div class="q1 a1">
          <span>A2</span>
          <p>请重启尝试，可能是第一次进入APP时网络权限未赋予完全导致。</p>
        </div>
        <div class="line"></div>
        <div class="q1 q3">
          <span>Q3</span>
          <p>软件没有声音，怎么回事啊？</p>
        </div>
        <div class="q1 a1">
          <span>A3</span>
          <p>请将静音模式关闭，左侧有可以上下掰动的按钮可以快速调整。</p>
        </div>
        <div class="line"></div>
        <div class="q1 q4">
          <span>Q4</span>
          <p>其他问题</p>
        </div>
        <div class="q1 a1">
          <span>A4</span>
          <p>请于早9:00～晚11:59，联系在线客服咨询，我们竭诚为您服务！</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    RnKey: {
      type: String,
    },
  },
  data() {
    return {
    };
  },
  created() {
  },
  methods: {
    downloadBtn() {
      // 埋点
      this.$sensors.track('LandingPage', {
        method: 'download',
        pid: 'M19',
        type: 'RN'
      });
      this.$emit("downloadRn");
    },
  },
};
</script>

<style lang="scss" scoped>
.RnDownload {
  padding: 0 16px;
  h1 {
    text-align: center;
    margin-top: 15px;
    color: #EAEAEA;
    font-family: PingFang SC;
    font-weight: 600;
    font-size: 18px;
  }
  .loadone {
    width: 343px;
    height: 120px;
    background-color: #222222;
    margin-top: 15px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    img {
      width: 70px;
      height: 70px;
      object-fit: cover;
    }
    .right {
      color: #EAEAEA;
      img {
      margin-top: 15px;
      width: 117px;
      height: 32px;
      object-fit: cover;
      }
    }
  }
  .tip {
    margin-top: 15px;
    font-size: 13px;
    color:#FFE362 ;
    span {
      color: #FF8C66;
    }
  }
  .tipone {
    font-size: 15px;
    color: #EAEAEA;
    margin-top: 15px;
  }
  .tips {
    margin-top: 16px;
    img {
      width: 100%;
      height: 26px;
      object-fit: cover;
    }
    p {
      margin-top: 9px;
      color: rgba(51, 51, 51, 1);
      font-size: 15px;
    }
    .key-box {
      border-radius: 8px;
      border: 1px solid rgba(230, 230, 230, 1);
      background: rgba(247, 247, 247, 1);
      box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.05);
      margin-top: 11px;
      padding: 10px 16px;
      word-wrap: break-word;
      text-align: left;
    }
    .copy {
      width: 152px;
      height: 41px;
      background: url("./images/copyKey@2x.png") no-repeat;
      background-size: cover;
      margin: 10px auto;
    }
    .go-download {
      width: 152px;
      height: 41px;
      background: url("./images/goDownload@2x.png") no-repeat;
      background-size: cover;
      margin: 10px auto;
    }
    .tips-bottom {
      padding: 16px 14px;
      border-radius: 16px;
      border: 0.5px solid rgba(221, 221, 221, 1);
      margin: 16px 0 39px 0;
      .line {
        transform: rotate(-0.089805deg);
        border: 0.1px solid #f5f4f4;
        margin: 16px 0;
      }
      .q1 {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        span {
          border-radius: 2px;
          background: linear-gradient(
            90deg,
            rgba(255, 226, 109, 1) 4.79%,
            rgba(247, 193, 67, 1) 100%
          );
          text-align: center;
          padding: 3px;
        }
        p {
          margin: 2px 0 0 13px;
          color: #EAEAEA;
          // font-weight: 700;
          font-size: 15px;
        }
      }
      .a1 {
        margin: 16px 0;
        span {
          background: rgba(224, 224, 224, 1);
        }
        p {
          font-weight: normal;
          font-size: 13px;
          color: #AAAAAA;
        }
      }
    }
  }
  .color-band {
    width: 343px;
    height: 90px;
    background: url("./images/color@2x.png") no-repeat;
    background-size: cover;
  }
  .installation {
    color: rgba(255, 0, 0, 1);
    font-size: 13px;
    margin: 10px 0;
  }
  .installation2 {
    color: rgba(51, 51, 51, 1);
    font-size: 15px;
  }
  .maintain {
    width: 317.5px;
    height: 217px;
    background: url("./images/weihu@2x.png") no-repeat;
    background-size: cover;
    margin: 10px 0 15px 0;
  }
}
</style>